<template>
  <kst-form no-bezel class="block">
    <template #top-right>
      <kst-button action-mode full-label
        class="is-primary"
        :module="Model.Module"
        :moduleType="Model.ModuleType.New"
      />
    </template>
  </kst-form>
</template>

<script>
import Model from "../RcpyModel.js";

export default {
  data: () => ({
    Model: Model
  })
}
</script>